import React, { useEffect, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataView } from "primereact/dataview";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import './Dashboard.css';

function CaseState({ selectedCase, refresh }) {
  
    const navigate = useNavigate();
    const [{ user, doctorList, statusList }, dispatch] = useStateValue();
    const [fields, setfields] = useState({
        doseSpotID: null,
        doctor_id: null,
        status: null,
       
    });
    const [stateDoctors, setStateDoctors] = useState([]);

   
  
    useEffect(() => {
        
         let doctorList_ = doctorList.filter(
             doctor => doctor.name.toUpperCase() === selectedCase.pharmacy_state.toUpperCase()
        );
        setStateDoctors(doctorList_);
    }, [])

    
   
    useEffect(() => {
        if (typeof selectedCase !== 'undefined') {
            setfields({
                state_id: selectedCase.state_id,
                doseSpotID: selectedCase.dose_spot_patient_id,
                doctor_id: selectedCase.dermatologist_id,
                status: selectedCase.status,
            });
        }
    }, [selectedCase])

   

   

    const callDoseSpot = () => {
        const url = "/api/doseSpot/CreateDoseSpot";
        // FirstName, MiddleName, LastName, DateOfBirth Gender Email Address1 Address2 City State State ZipCode PrimaryPhone PrimaryPhoneType Weight WeightMetric:1 Height HeightMetric:1 Active:true

        const params =
        {
            FirstName: selectedCase.first_name,
            MiddleName: selectedCase.middle_initial,
            LastName: selectedCase.last_name,
            DateOfBirth: selectedCase.dob,
            Gender: selectedCase.gender,
            Email: selectedCase.email,
            Address1: selectedCase.address_1,
            Address2: selectedCase.address_2,
            City: selectedCase.patient_city,
            State: selectedCase.patient_state,
            ZipCode: selectedCase.patient_zip,
            PrimaryPhone: selectedCase.phone,
            PrimaryPhoneType: 2,
            Weight: 0,
            WeightMetric: 1,
            Height: 0,
            HeightMetric: 1,
            Active: true
        };
      
        axios
            .post(url, params)
            .then((response) => {
                if (response.status === 200) {
                    let res = JSON.parse(response.data.DoseSpotPatient);
                    if (res.Result.ResultCode === 'OK') {
                        let doseSpotID = res.Id;
                        setfields({ ...fields, doseSpotID: doseSpotID });
                    }
                    else {

                        alert("Error while creating:" + res.Result.ResultDescription );
                    }
                   
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Error fetching pharmacy info.");
            });
    };

    const saveCaseState = () => {
        const url = "/api/ha/SaveChanges";

        if (fields.status === 'assigned' || fields.status === 'diagnosed'
            || fields.status === 'prescribed' || fields.status === 'more_info')
        {
            if ((fields.doctor_id === undefined || fields.doctor_id === null) || fields.doseSpotID === null) {
                alert('Doctor and doseSpotID are required');
                return false;
            }
        }

        if (fields.status === 'pending' || fields.status === 'initiate')
        {
           setfields({ ...fields, doctor_id: null })
        }

        const params = {
            actionType: 'UpdateCaseStatusAndAssignDoctor',
            casetype: selectedCase.casetype,
            caseID: selectedCase.id,
            refillID: selectedCase.refillID,
            status: fields.status,
            dermatologist_id: fields.status === 'pending' || fields.status === 'initiate' ? null :fields.doctor_id,
            dose_spot_patient_id: fields.doseSpotID,
            user: user.id

        };

        axios
            .post(url, params)
            .then((response) => {
                if (response.data.status === 'OK') {
                    refresh();
                    alert("Saved successfully!");
                }
                else {
                    alert(response.data.errMsg);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Error:" + error);
            });
    };

   
    const doctorOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.display_name + ' - ' + option.name}</div>
            </div>
        );
    };

    return (
        <div className="container mt-1">
            
                      
                <div className="mt-0">
                {

                    selectedCase &&
                    <div className="display-6">
                            {selectedCase.first_name && <span className="fs-2"> {selectedCase.first_name} {selectedCase.middle_initial} {selectedCase.last_name} - {selectedCase.pharmacy_state}  </span>}
                        <span className="ml-3 fs-4">Token:{selectedCase.token} {selectedCase.casetype === 'Case' ? 'Case:' + selectedCase.id : 'Refill:' + selectedCase.refillID} </span>
                    </div>
                }
                <hr />
                    <div className="card shadow-lg" >
                       
                        <div className="card-body">
                            {selectedCase ? (
                                <>
                                    
                                    <div><strong>Status:</strong>
                                        <Dropdown 
                                            value={fields.status} 
                                            options={statusList} 
                                            onChange={(e) => setfields({ ...fields, status: e.value })} 
                                            optionLabel='label'
                                            optionValue='value'
                                            placeholder="Select a Status" 
                                        />
                                </div>
                                <div className="mt-2"><strong>DoseSpot:</strong> {fields.doseSpotID || (
                                        <a href="#" onClick={callDoseSpot}>Create DoseSpot</a>
                                    )}</div>
                                <div className="mt-2"><strong>Select Doctor:</strong>
                                    <Dropdown 
                                            filter 
                                            showClear
                                            value={fields.doctor_id} 
                                            options={stateDoctors} 
                                            onChange={(e) => setfields({ ...fields, doctor_id: e.value })} 
                                            optionLabel='display_name'
                                            optionValue='id'
                                            placeholder="Select a Doctor" 
                                            itemTemplate={doctorOptionTemplate}
                                           
                                        />
                                </div>
                                <div>
                                    { selectedCase.DrName !== null ? <span>Current Doctor: {selectedCase.DrName}</span>: null}
                                </div>
                                </>
                            ) : (
                                <p>Loading case state info...</p>
                            )}
                    </div>
                    <Button label="Save Changes" onClick={saveCaseState} className="mt-4" />
                </div>
               
                </div>
            
            
        </div>
       
    );

}
export default CaseState;